import { Component } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ModalContent } from '@ap/modal';

import content from './phonenumber-validation-moreinfo-modal.content.json';
@Component({
    templateUrl: './phonenumber-validation-moreinfo-modal.component.html',
    standalone: false
})
export class PhonenumberValidationMoreInfoModalComponent extends ModalContent<void> {
    constructor(private readonly apContentService: ApContentService) {
        super();
        this.apContentService.addContentItems(content);
    }
}
